<template>
  <section class="about-us-hiring text-center">
    <div class="page-container">
      <h2 class="about-us-hiring__title mb4">
        We&rsquo;re
        <em>hiring.</em>
        Join&nbsp;us.
      </h2>

      <p class="about-us-hiring__subtitle">
        We&rsquo;re hiring across all departments to&nbsp;expand the global career landscape for salespeople.
        We&nbsp;believe the future of&nbsp;sales is&nbsp;accessible, diverse, and inclusive. We&rsquo;re a&nbsp;100%
        remote workforce with employees around the world&nbsp;&mdash; all passionate about helping salespeople
        be&nbsp;more successful in&nbsp;their careers.
      </p>
      <p class="about-us-hiring__subtitle--help-us">Come help take&nbsp;us to&nbsp;the next level!</p>

      <div class="about-us-hiring__link">
        <NuxtLink data-test="about-page-hiring-button" :to="$pages.CAREERS_PAGE">Work @ Bravado</NuxtLink>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'AboutUsHiring',
  methods: {
    async handleClick() {
      await this.$router.push(this.$pages.CAREERS_PAGE);
    },
  },
});
</script>

<style lang="scss" scoped>
.about-us-hiring {
  padding: 60px 0 73px;

  &__title {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    color: var(--white);

    @include mq('md') {
      font-size: 49px;
      line-height: 60px;
      letter-spacing: -1.45366px;
      margin-bottom: 35px;
    }

    em {
      font-style: normal;

      @include mq('md') {
        font-style: italic;
        color: var(--theme-purple_hc_1);
      }
    }
  }

  &__subtitle {
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: var(--gray-20);
    margin: 0 auto 20px;
    max-width: 790px;

    @include mq('md') {
      font-size: 20px;
      line-height: 32px;
      margin: 0 auto 20px;
    }

    &--help-us {
      display: block;
      font-size: 20px;
      color: var(--theme-purple_hc_1);
      padding: 24px 0 30px;

      @include mq('md') {
        display: block;
        color: var(--theme-purple_hc_1);
        padding: 35px 0 40px;
      }
    }
  }

  &__link {
    position: relative;
    z-index: 1;

    a {
      padding: 20px 40px;
      color: white;
      background: linear-gradient(82.4deg, #755275 0%, #8a92ce 106.45%);
      border-radius: 10px;
      cursor: pointer;
      font-weight: 600;
    }
  }
}
</style>
